(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-product-root]');
    if (!root) return;

    const form = root.querySelector('[data-product-form]');
    const select = root.querySelector('[data-variant-select]');
    const jsonEl = root.querySelector('[data-variant-json]');
    const stringsEl = root.querySelector('[data-product-strings]');
    const addButton = root.querySelector('[data-add-button]');
    const priceEl = root.querySelector('[data-product-price]');
    const stockEl = root.querySelector('.product__stock');
    const slides = Array.from(root.querySelectorAll('[data-gallery-slide]'));
    const thumbs = Array.from(root.querySelectorAll('[data-gallery-thumb]'));

    let strings = {
      addToCart: 'Add to cart',
      soldOut: 'Sold out',
      unavailable: 'Unavailable',
      inStock: 'In stock'
    };

    try {
      if (stringsEl) strings = JSON.parse(stringsEl.textContent);
    } catch (error) {
      // Keep defaults
    }

    function showImage(imageId) {
      if (!imageId || !slides.length) return;
      slides.forEach((slide) => {
        const match = String(slide.dataset.imageId) === String(imageId);
        slide.hidden = !match;
        slide.classList.toggle('is-active', match);
      });
      thumbs.forEach((thumb) => {
        const match = String(thumb.dataset.imageId) === String(imageId);
        thumb.classList.toggle('is-active', match);
        if (match) {
          thumb.setAttribute('aria-current', 'true');
        } else {
          thumb.removeAttribute('aria-current');
        }
      });
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => showImage(thumb.dataset.imageId));
    });

    if (!form || !select) return;

    let variants = [];
    try {
      variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
    } catch (error) {
      variants = [];
    }

    function selectedOptions() {
      return Array.from(root.querySelectorAll('[data-option-index]')).map((group) => {
        const checked = group.querySelector('input:checked');
        return checked ? checked.value : '';
      });
    }

    function findVariant() {
      const options = selectedOptions();
      if (!options.length) {
        return variants.find((variant) => String(variant.id) === String(select.value));
      }
      return variants.find((variant) =>
        (variant.options || []).every((option, index) => option === options[index])
      );
    }

    function updateUI(variant) {
      if (!variant) {
        addButton.disabled = true;
        addButton.textContent = strings.unavailable;
        return;
      }

      select.value = String(variant.id);
      addButton.disabled = !variant.available;
      addButton.textContent = variant.available ? strings.addToCart : strings.soldOut;

      if (stockEl) {
        stockEl.textContent = variant.available ? strings.inStock : strings.soldOut;
        stockEl.classList.toggle('product__stock--out', !variant.available);
      }

      if (priceEl) {
        if (variant.compare) {
          priceEl.innerHTML =
            '<div class="price"><span class="price__sale">' +
            variant.price +
            '</span><s class="price__compare">' +
            variant.compare +
            '</s></div>';
        } else {
          priceEl.innerHTML = '<div class="price"><span>' + variant.price + '</span></div>';
        }
      }

      if (variant.imageId) {
        showImage(variant.imageId);
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    root.querySelectorAll('[data-option-input]').forEach((input) => {
      input.addEventListener('change', () => updateUI(findVariant()));
    });

    select.addEventListener('change', () => {
      const variant = variants.find((item) => String(item.id) === String(select.value));
      updateUI(variant);
    });

    root.querySelectorAll('[data-qty]').forEach((button) => {
      button.addEventListener('click', () => {
        const field = root.querySelector('input[name="quantity"]');
        const next = Math.max(1, Number(field.value || 1) + Number(button.dataset.qty));
        field.value = String(next);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
